var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 44 44",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11C12.6868 11 10 13.7337 10 17.1065C10 19.8291 11.05 26.2909 21.3856 32.8229C21.5707 32.9387 21.7833 33 22 33C22.2167 33 22.4293 32.9387 22.6144 32.8229C32.95 26.2909 34 19.8291 34 17.1065C34 13.7337 31.3132 11 28 11C24.6868 11 22 14.7009 22 14.7009C22 14.7009 19.3132 11 16 11Z",
    fill: "currentColor",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11C12.6868 11 10 13.7337 10 17.1065C10 19.8291 11.05 26.2909 21.3856 32.8229C21.5707 32.9387 21.7833 33 22 33C22.2167 33 22.4293 32.9387 22.6144 32.8229C32.95 26.2909 34 19.8291 34 17.1065C34 13.7337 31.3132 11 28 11C24.6868 11 22 14.7009 22 14.7009C22 14.7009 19.3132 11 16 11Z",
    stroke: "inherit",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSmall);
export default __webpack_public_path__ + "static/media/heartSmall.02aed6bf9b1f9a0794334590ad53901e.svg";
export { ForwardRef as ReactComponent };